import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';
import type {RouletteMainResponseVo} from '../../common/shared/api/nicolas/vo/RouletteMainResponseVo.interface';

/**
 * 룰렛 정보 조회 (v3 Web)
 *
 * Origin: pageNicolasApi.getRouletteInfoWeb
 * API: POST /api/v3/gotcha
 */
export async function postRouletteGetWeb(
  {
    rouletteId,
    rouletteAdLocId,
  }: {
    rouletteId: string;
    rouletteAdLocId?: string;
  },
  options?: FetcherOptions
): Promise<
  ApiResultVo & {gotcha_id: string; gotcha_info: RouletteMainResponseVo}
> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v3/gotcha',
    {
      method: 'POST',
      data: {
        map_uid: rouletteId,
        ad_loc_id: rouletteAdLocId,
      },
    },
    options
  );
  return response.data;
}
